import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  const { isUserLoggedIn, activePopUp } = styles;
  return StyleSheet.create({
    welcomeLinkContainer: {
      position: 'relative',
      display: 'none',
      flexDirection: 'row',
      cursor: 'default',
      fontSize: 14,

      [children('img')]: {
        marginRight: 10,
        marginTop: 10,
        height: '52px',
        width: 'auto',
      },

      [media.tablet]: {
        display: 'flex',
        marginLeft: 10,
      },

      [media.desktop]: {
        fontSize: 16,
        marginLeft: 15,
      },
    },
    welcomeLink: {
      display: isUserLoggedIn ? 'flex' : 'none',
      textAlign: 'right',
      cursor: 'default',

      [children('a')]: {
        whiteSpace: 'nowrap',
        color: palette.white,
        marginTop: 5,
        fontWeight: 700,
        cursor: 'pointer',
        fontSize: 12,
      },

      [media.tablet]: {
        display: 'flex',
        flexDirection: 'column',
      },

      [media.desktop]: {
        display: 'flex',
        flexDirection: 'column',

        [children('a')]: {
          fontSize: 14,
          alignItems: 'flex-end',
        },

        ':hover': {
          background: '#000',
        },
      },

      [media.xl]: {
        [children('a')]: {
          fontSize: 14,
        },
      },
    },

    welcomeString: {
      display: 'none',
      cursor: 'default',
      [children('.welcome-text')]: {
        display: 'block',
        marginTop: '14px',
      },

      [media.tablet]: {
        display: 'block',
        textAlign: 'right',
      },

      [media.xl]: {
        whiteSpace: 'nowrap',
        fontSize: 16,
      },
    },
    toolTipContainer: {
      position: 'absolute',
      zIndex: 10,
      top: '100%',
      right: 0,
      display: 'none',
      background: 'transparent',
      width: '200px',
      cursor: 'default',
      [media.tablet]: {
        display: activePopUp ? 'block' : 'none',
        right: 0,
      },
      [media.desktop]: {
        left: '-50%',
      },
    },
    toolTip: {
      position: 'relative',
      width: '100%',
      marginTop: 15,
      padding: 10,
      fontSize: 14,
      lineHeight: '20px',
      color: palette.white,
      background: palette.lightDarkGrey,
      borderRadius: '5px',

      ':before': {
        display: 'block',
        position: 'absolute',
        content: '""',
        width: 0,
        height: 0,
        borderBottom: `8px solid ${palette.lightDarkGrey}`,
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        top: '-8px',
        right: '80px',
        [media.desktop]: {
          right: 0,
          left: '70px',
        },
      },
      [children('a')]: {
        display: 'inline-block',
        cursor: 'pointer',
        borderRadius: '5px',
        background: palette.red,
        color: palette.white,
        padding: '5px 10px',
        border: 0,
      },
    },
    activeToolTip: {
      visibility: 'visible',
    },
    toolTipHeadline: {
      fontWeight: 700,
      fontSize: 18,
      display: 'inline-block',
    },
    toolTipParagraph: {
      fontSize: 14,
      display: 'inline-block',
      marginBottom: 10,
    },

    // mobile nav related things
    welcomeLinkMobileContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',

      [children('img')]: {
        marginRight: 10,
      },

      [media.tablet]: {
        display: 'none',
      },

      [children('ul')]: {
        diplay: 'none',
      },
    },
    collapsedSubMenu: {
      display: 'none',
    },
    expandedSubMenu: {
      diplay: 'block',
      listStyle: 'none',
    },
    arrowDown: {
      width: 0,
      height: 0,
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderTop: `5px solid ${palette.red}`,
    },
    arrowUp: {
      width: 0,
      height: 0,
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderBottom: `5px solid ${palette.red}`,
    },
  });
};
